export const PERSONATE_REGEX = /@personate\b/
export const PERSON8_REGEX = /@person8\b/
export const GMAIL_REGEX = /@gmail\b/
export const CONTENT_TYPE = "Content-Type"
export const APPLICATION_JSON = "application/json"
export const X_ACCESS_TOKEN = "x-access-token"
export const RANDOM_AVATAR_IMAGE_URL = "https://i.pravatar.cc/100"
export const ONE = "1"
export const ZERO = "0"